import React, { useState, useEffect } from 'react';
import * as api from '../services/apiService';
import { useNavigation } from '../contexts/NavigationProvider';
import type { Opportunity } from '../types';
import ListBulletIcon from './icons/ListBulletIcon';

const MyLineupsPage: React.FC = () => {
    const { handleViewLineupEditor } = useNavigation();
    const [opportunities, setOpportunities] = useState<Opportunity[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchLineupOpps = async () => {
            try {
                const data = await api.getLineupOpportunities();
                setOpportunities(data);
            } catch (err) {
                const message = err instanceof Error ? err.message : 'An unknown error occurred.';
                setError(message);
            } finally {
                setLoading(false);
            }
        };
        fetchLineupOpps();
    }, []);

    return (
        <div className="space-y-6">
            <div className="bg-brand-surface rounded-lg p-6">
                <div className="flex items-center space-x-3">
                    <ListBulletIcon className="h-7 w-7 text-brand-orange" />
                    <h2 className="text-3xl font-bold text-white">My Lineups</h2>
                </div>
                <p className="mt-2 text-brand-muted">
                    Manage event lineups and create promotional flyers for your events.
                </p>
            </div>
            
            <div className="bg-brand-surface rounded-lg p-6">
                {loading && <p className="text-brand-muted">Loading your events...</p>}
                {error && <p className="text-red-400">Error: {error}</p>}
                {!loading && !error && (
                    opportunities.length > 0 ? (
                        <ul className="space-y-4">
                            {opportunities.map(opp => (
                                <li key={opp.id} className="bg-gray-800/50 p-4 rounded-lg flex justify-between items-center">
                                    <div>
                                        <h3 className="font-bold text-lg text-white">{opp.title}</h3>
                                        <p className="text-sm text-brand-muted">{opp.applications.length} submitted applicants</p>
                                    </div>
                                    <button
                                        onClick={() => handleViewLineupEditor(opp)}
                                        className="bg-brand-orange text-white font-bold px-4 py-2 rounded-full text-sm hover:opacity-90"
                                    >
                                        Manage Lineup
                                    </button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-center text-brand-muted py-8">
                            No events found. Post an event or get accepted to a gig to create a lineup.
                        </p>
                    )
                )}
            </div>
        </div>
    );
};

export default MyLineupsPage;